import FingoPaper from '@fingo/lib/components/layout/FingoPaper';
import React from 'react';
import { purchaseTabs } from '../../../routes/purchases';

const PurchasesSidePayable = () => {
  const tabs = purchaseTabs();
  return <FingoPaper tabs={tabs} />;
};

export default PurchasesSidePayable;
